import type { BaseConfig } from '@/workflow/_contract/config';
import { COLOR_PALETTES } from '@/workflow/_data/config/fragments/colorPalettes';

export type ToolStepLayoutConfig = BaseConfig['domainPresentation']['entities']['toolSteps'];

export type CasesConfig = BaseConfig['domainPresentation']['entities']['cases']['bands'] & { colorNearWhen: string; colorNearWhat: string };

export type MacroStepConnectorsConfig =
    BaseConfig['domainPresentation']['connectors']['macroStep'];

export type WorkflowStateEntriesConfig =
    BaseConfig['domainPresentation']['entities']['workflowStateEntries'];

export function resolveCasesConfig(config: BaseConfig): CasesConfig {
    return { ...config.domainPresentation.entities.cases.bands, ...COLOR_PALETTES[config.colorPalette].cases.bands };
}

export function resolveMacroStepConnectorsConfig(
    config: BaseConfig,
): MacroStepConnectorsConfig {
    return config.domainPresentation.connectors.macroStep;
}

export function resolveToolStepLayoutConfig(config: BaseConfig): ToolStepLayoutConfig {
    return config.domainPresentation.entities.toolSteps;
}

export function resolveWorkflowStateEntriesConfig(config: BaseConfig): WorkflowStateEntriesConfig {
    return config.domainPresentation.entities.workflowStateEntries;
}

export function isResourceTypeRadialConnectorsEnabled(config: BaseConfig): boolean {
    return config.domainPresentation.connectors.resourceTypeRadial.enabled;
}

export function isWorkflowStateEntryConnectorsEnabled(config: BaseConfig): boolean {
    return config.domainPresentation.connectors.workflowStateEntry.enabled;
}

export function isMacroStepConnectorsEnabled(config: BaseConfig): boolean {
    return config.domainPresentation.connectors.macroStep.enabled;
}

export function getResourceTypeRingRadius(config: BaseConfig): number {
    return getToolRingOuterRadius(config)
        * config.geometryScale.multipliers.resourceTypes.ringRadiusFromRoot;
}

export function getToolRingOuterRadius(config: BaseConfig): number {
    return config.domainPresentation.entities.tools.layout.outerRadius;
}

export function getToolStepRingGap(config: BaseConfig): number {
    return getResourceTypeRingRadius(config)
        * config.geometryScale.multipliers.toolSteps.ringGapFromResourceTypeRing;
}